import React from "react"

import {
  NewProductPositionOverlayView,
  NewProductPositionOverlayViewModel
} from "./NewProductPositionOverlayView"

export interface NewProductPositionOverlayModel
  extends NewProductPositionOverlayViewModel {}

export interface NewProductPositionOverlayProps
  extends NewProductPositionOverlayViewModel {
  autoFocus?: boolean
}

export const NewProductPositionOverlay = React.memo(
  (props: NewProductPositionOverlayProps) => (
    <NewProductPositionOverlayView {...props} />
  )
)
